import {FormControl, Search as PlatformSearch} from 'platform/components';

import {useCallback} from 'react';
import {useController} from 'react-hook-form';

import {isNotNil, juxt} from 'ramda';

import {noop, TestIdProps} from 'shared/web';

import {FilterFormData} from '../../../types/FilterFormData';

interface SearchProps extends TestIdProps {
  placeholder: string;
  name: keyof FilterFormData;
  control: FormControl<FilterFormData>;
}

export function Search(props: SearchProps) {
  const {
    field: {value, onChange: fieldOnChange},
  } = useController(props);
  const controlOnChange = props.control.onChange;

  // Use the same pattern as platform FormField components
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onChange = juxt<any[], unknown>([fieldOnChange, controlOnChange ?? noop]);

  const handleClear = useCallback(() => {
    onChange(null);
  }, [onChange]);

  return (
    <PlatformSearch
      value={isNotNil(value) ? value.toString() : null}
      placeholder={props.placeholder}
      onChange={onChange}
      onClear={handleClear}
    />
  );
}
